function ownKeys(e, r) {
  var t = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    r && (o = o.filter(function(r2) {
      return Object.getOwnPropertyDescriptor(e, r2).enumerable;
    })), t.push.apply(t, o);
  }
  return t;
}
function _objectSpread(e) {
  for (var r = 1; r < arguments.length; r++) {
    var t = null != arguments[r] ? arguments[r] : {};
    r % 2 ? ownKeys(Object(t), true).forEach(function(r2) {
      _defineProperty(e, r2, t[r2]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function(r2) {
      Object.defineProperty(e, r2, Object.getOwnPropertyDescriptor(t, r2));
    });
  }
  return e;
}
function _defineProperty(e, r, t) {
  return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: true, configurable: true, writable: true }) : e[r] = t, e;
}
function _toPropertyKey(t) {
  var i = _toPrimitive(t, "string");
  return "symbol" == typeof i ? i : i + "";
}
function _toPrimitive(t, r) {
  if ("object" != typeof t || !t)
    return t;
  var e = t[Symbol.toPrimitive];
  if (void 0 !== e) {
    var i = e.call(t, r || "default");
    if ("object" != typeof i)
      return i;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return ("string" === r ? String : Number)(t);
}
import { jsx } from "panel";
import { ButtonEl } from "common/components/button";
import { ButtonTheme } from "common/components/button/constants";
import { SvgIconEl } from "common/components/svg-icon";
import { ExperimentalTooltipEl, TooltipEl } from "common/components/tooltip";
import { Placement } from "common/components/tooltip/types";
import { NarrowMode, ToggleSize, ToggleTheme } from "./types";
function IconContainer(attrs) {
  const {
    icon
  } = attrs;
  return /* @__PURE__ */ jsx("div", { sel: ".icon-container", attrs: {
    icon
  }, "data-sentry-component": "IconContainer", "data-sentry-source-file": "template.tsx" }, /* @__PURE__ */ jsx(SvgIconEl, { attrs: {
    icon
  }, "data-sentry-element": "SvgIconEl", "data-sentry-source-file": "template.tsx" }));
}
export function template() {
  const options = this.helpers.toggleOptions();
  const {
    narrowMode
  } = this.state;
  const selectedIndex = (options || []).findIndex((toggleOption) => toggleOption.value === this.attr("selected"));
  const theme = this.attr("theme");
  const hideTooltip = theme === "tab-bar-heavy" && narrowMode !== NarrowMode.OnlyIcons;
  const {
    print
  } = this.getContext("i18n");
  return /* @__PURE__ */ jsx("div", { sel: ".mp-toggle", class: {
    "toggle-large": this.attr("size") === ToggleSize.Large,
    "theme-tabbar": theme === ToggleTheme.TabBar,
    "theme-tabbar-borderless": theme === ToggleTheme.TabBarBorderless,
    "theme-tabbar-lite": theme === ToggleTheme.TabBarLite,
    "theme-tabbar-heavy": theme === ToggleTheme.TabBarHeavy,
    "theme-segcon": theme === ToggleTheme.SegmentedController,
    "theme-large-font": theme === ToggleTheme.TabBarLargeFont
  }, hook: {
    insert: (vnode) => this.wrapperInserted(vnode)
  }, "data-sentry-component": "template", "data-sentry-source-file": "template.tsx" }, options.map((toggleOption, index) => {
    const isSelected = index === selectedIndex;
    const beforeSelected = index === selectedIndex - 1;
    const {
      icon,
      iconColor,
      value,
      disabled,
      tooltip,
      tooltipLabel,
      href
    } = toggleOption;
    const label = print(toggleOption.label);
    const showLabel = label.length && narrowMode !== NarrowMode.OnlyIcons;
    const hasTextAndIcon = Boolean(icon && showLabel);
    let tooltipEl = null;
    if (tooltip) {
      tooltipEl = /* @__PURE__ */ jsx(TooltipEl, { attrs: tooltip });
    } else if (tooltipLabel) {
      tooltipEl = /* @__PURE__ */ jsx(TooltipEl, { attrs: {
        placement: Placement.Top,
        text: tooltipLabel
      } });
    }
    return theme === "segmented-controller" ? /* @__PURE__ */ jsx("div", { sel: ".mp-toggle-option", class: {
      selected: isSelected
    } }, /* @__PURE__ */ jsx(ButtonEl, { sel: ".mp-toggle-button", attrs: {
      theme: ButtonTheme.Tertiary,
      // @ts-ignore Type 'ToggleSize' is not assignable to type 'ButtonSize'.
      size: this.attr("size"),
      icon,
      disabled,
      selected: isSelected,
      "not-focusable": true,
      href
    }, on: {
      click: () => !disabled && this.helpers.selectOption(value)
    } }, label), tooltipEl) : /* @__PURE__ */ jsx("a", { sel: ".mp-toggle-option", class: {
      "mp-toggle-selected": isSelected,
      "before-selected": beforeSelected,
      "mp-toggle-disabled": disabled,
      "mp-toggle-text-and-icon": hasTextAndIcon,
      "has-label": showLabel
    }, style: {
      "--selected-toggle-icon-color": iconColor
    }, on: {
      click: () => !disabled && this.helpers.selectOption(value),
      mouseenter: () => this.hovered(value),
      mouseleave: () => this.cancelHover()
    }, attrs: _objectSpread(_objectSpread({}, href ? {
      href
    } : {}), {}, {
      role: "tab"
    }) }, /* @__PURE__ */ jsx("div", { sel: ".container" }, icon ? /* @__PURE__ */ jsx(IconContainer, { icon }) : null, showLabel ? label : null), /* @__PURE__ */ jsx("div", { sel: ".highlight-bar" }), !hideTooltip && tooltipLabel ? /* @__PURE__ */ jsx(ExperimentalTooltipEl, { attrs: {
      placement: Placement.Top,
      text: tooltipLabel
    } }) : null);
  }));
}
